<template>
  <div :class="stepNumber == 1 ? 'block' : 'hidden'">
    <h1 class="registration-form-layout__title">{{ accountDetailsFormTitle }}</h1>

    <div class="account-details-outer-form registration-form-layout flex"
    >
    <!-- :class="stepNumber == 1 ? 'flex' : 'hidden'" -->
      <p class="registration-form-layout__note"><b>{{locales && locales.subscription && locales.subscription.account_created}}</b> {{locales && locales.subscription && locales.subscription.fill_search_profile}}</p>

      <div
        v-if="numberOfAdults > 0"
        v-for="adult in numberOfAdults"
        :key="adult"
      >
        <account-details-inner-form
          :i="adult - 1"
          :subscriptionsIncome="subscriptionsIncome"
          :subscriptionsTypeOfIncomeInput="subscriptionsTypeOfIncomeInput"
          :subscriptionsTypeOfIncomePlaceholder="subscriptionsTypeOfIncomePlaceholder"
          :subscriptionsTypeOfIncomeOptions="subscriptionsTypeOfIncomeOptions"
          :subscriptionsTypeOfIncomeSlugs="subscriptionsTypeOfIncomeSlugs"
          :usersDoYouHaveGuarantorGeneral="usersDoYouHaveGuarantorGeneral"
          :usersDoYouHaveGuarantorInput="usersDoYouHaveGuarantorInput"
          :usersDoYouHaveGuarantorOptions="usersDoYouHaveGuarantorOptions"
          :usersContractType="usersContractType"
          :usersContractTypeInput="usersContractTypeInput"
          :usersContractTypeOptions="usersContractTypeOptions"
          :usersContractTypeAttributes="usersContractTypeAttributes"
          :usersContractDuration="usersContractDuration"
          :usersContractDurationInput="usersContractDurationInput"
          :usersContractDurationPlaceholder="usersContractDurationPlaceholder"
          :usersContractEndDate="usersContractEndDate"
          :usersContractEndDateInput="usersContractEndDateInput"
          :usersContractEndDatePlaceholder="usersContractEndDatePlaceholder"
          :usersOccupation="usersOccupation"
          :usersOccupationInput="usersOccupationInput"
          :usersOccupationPlaceholder="usersOccupationPlaceholder"
          :usersMonthlyIncome="usersMonthlyIncome"
          :usersMonthlyIncomeInput="usersMonthlyIncomeInput"
          :usersStudy="usersStudy"
          :usersStudyInput="usersStudyInput"
          :usersStudyPlaceholder="usersStudyPlaceholder"
          :usersGuarantorIncome="usersGuarantorIncome"
          :usersGuarantorIncomeInput="usersGuarantorIncomeInput"
          :usersGuarantorIncomePlaceholder="usersGuarantorIncomePlaceholder"
          :usersExtraInformationIncome="usersExtraInformationIncome"
          :usersExtraInformationIncomeInput="usersExtraInformationIncomeInput"
          :usersExtraInformationIncomePlaceholder="usersExtraInformationIncomePlaceholder"
          :subscriptionsPostCode="subscriptionsPostCode"
          :subscriptionsPostCodePlaceholder="subscriptionsPostCodePlaceholder"
          :subscriptionsHouseNumber="subscriptionsHouseNumber"
          :subscriptionsHouseNumberPlaceholder="subscriptionsHouseNumberPlaceholder"
          :subscriptionsHouseNumberAppendix="subscriptionsHouseNumberAppendix"
          :subscriptionsHouseNumberAppendixPlaceholder="subscriptionsHouseNumberAppendixPlaceholder"
          :subscriptionsHouseNumberAppendixExtra="subscriptionsHouseNumberAppendixExtra"
          :subscriptionsHouseNumberAppendixExtraPlaceholder="subscriptionsHouseNumberAppendixExtraPlaceholder"
          :subscriptionsStreet="subscriptionsStreet"
          :subscriptionsStreetPlaceholder="subscriptionsStreetPlaceholder"
          :subscriptionsCity="subscriptionsCity"
          :subscriptionsCityPlaceholder="subscriptionsCityPlaceholder"
          :usersLandlordDetails="usersLandlordDetails"
          :usersLandlordLabel="usersLandlordLabel"
          :usersLandlordRadio="usersLandlordRadio"
          :usersLandlordOptions="usersLandlordOptions"
          :usersLandlordName="usersLandlordName"
          :usersLandlordNamePlaceholder="usersLandlordNamePlaceholder"
          :usersLandlordEmail="usersLandlordEmail"
          :usersLandlordEmailPlaceholder="usersLandlordEmailPlaceholder"
          :usersLandlordPhone="usersLandlordPhone"
          :usersLandlordPhonePlaceholder="usersLandlordPhonePlaceholder"
          :landlordTypeState="landlordTypeState"
          :subscriptionsSexInput="subscriptionsSexInput"
          :subscriptionsSexInputTitle="subscriptionsSexInputTitle"
          :subscriptionsSexOptions="subscriptionsSexOptions"
          :defaultLanguage="defaultLanguage"
          :languages="languages"
          :subscriptionsFamilyStatusTitle="subscriptionsFamilyStatusTitle"
          :subscriptionsCivilStatus="subscriptionsCivilStatus"
          :subscriptionsCivilStatusOptions="subscriptionsCivilStatusOptions"
          :subscriptionsChildren="subscriptionsChildren"
          :subscriptionsChildrenOptions="subscriptionsChildrenOptions"
          :subscriptionsPets="subscriptionsPets"
          :subscriptionsPetsOptions="subscriptionsPetsOptions"
          :subscriptionsExtraDetailsTitle="subscriptionsExtraDetailsTitle"
          :subscriptionsSmoking="subscriptionsSmoking"
          :subscriptionsIAm="subscriptionsIAm"
          :usersAddress="usersAddress"
        ></account-details-inner-form>
      </div>
    
      <button
        id="submitAccDetailsFormBtn"
        class="theme-btn theme-btn--theme theme-btn--block"
        type="submit"
        @click.prevent="submitForm"
      >
        {{ commonSubmit }}
      </button>

    </div>
  </div>
</template>

<script>
import $ from "jquery";
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
  },
  // data() {},
  computed: {
    ...mapGetters(["locales"]),
    stepNumber: function() {
      return this.$store.state.registrationStep.stepNumber;
    },
    numberOfAdults: function() {
      return this.$store.state.registrationStep.numberOfAdults;
    },
  },
  props: {
    accountDetailsFormTitle: {
      default: "",
      type: String,
    },
    subscriptionsIncome: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeInput: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsTypeOfIncomeSlugs: {
      default: () => {},
      type: Object,
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorInput: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object,
    },
    usersContractType: {
      default: "",
      type: String,
    },
    usersContractTypeInput: {
      default: "",
      type: String,
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractDuration: {
      default: "",
      type: String,
    },
    usersContractDurationInput: {
      default: "",
      type: String,
    },
    usersContractDurationPlaceholder: {
      default: "",
      type: String,
    },
    usersContractEndDate: {
      default: "",
      type: String,
    },
    usersContractEndDateInput: {
      default: "",
      type: String,
    },
    usersContractEndDatePlaceholder: {
      default: "",
      type: String,
    },
    usersOccupation: {
      default: "",
      type: String,
    },
    usersOccupationInput: {
      default: "",
      type: String,
    },
    usersOccupationPlaceholder: {
      default: "",
      type: String,
    },
    usersMonthlyIncome: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeInput: {
      default: "",
      type: String,
    },
    usersStudy: {
      default: "",
      type: String,
    },
    usersStudyInput: {
      default: "",
      type: String,
    },
    usersStudyPlaceholder: {
      default: "",
      type: String,
    },
    usersGuarantorIncome: {
      default: "",
      type: String,
    },
    usersGuarantorIncomeInput: {
      default: "",
      type: String,
    },
    usersGuarantorIncomePlaceholder: {
      default: "",
      type: String,
    },
    usersExtraInformationIncome: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomeInput: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsPostCode: {
      default: "",
      type: String,
    },
    subscriptionsPostCodePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumber: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendix: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendixPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendixExtra: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendixExtraPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsStreet: {
      default: "",
      type: String,
    },
    subscriptionsStreetPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsCity: {
      default: "",
      type: String,
    },
    subscriptionsCityPlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordDetails: {
      default: "",
      type: String,
    },
    usersLandlordLabel: {
      default: "",
      type: String,
    },
    usersLandlordRadio: {
      default: "",
      type: String,
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object,
    },
    usersLandlordName: {
      default: "",
      type: String,
    },
    usersLandlordNamePlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordEmail: {
      default: "",
      type: String,
    },
    usersLandlordEmailPlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordPhone: {
      default: "",
      type: String,
    },
    usersLandlordPhonePlaceholder: {
      default: "",
      type: String,
    },
    landlordTypeState: {
      default: "-1",
      type: String,
    },
    subscriptionsSexInput: {
      default: "",
      type: String,
    },
    subscriptionsSexInputTitle: {
      default: "",
      type: String,
    },
    subscriptionsSexOptions: {
      default: () => {},
      type: Object,
    },
    defaultLanguage: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
    subscriptionsFamilyStatusTitle: {
      default: "",
      type: String,
    },
    subscriptionsCivilStatus: {
      default: "",
      type: String,
    },
    subscriptionsCivilStatusOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsChildren: {
      default: "",
      type: String,
    },
    subscriptionsChildrenOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsPets: {
      default: "",
      type: String,
    },
    subscriptionsPetsOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsExtraDetailsTitle: {
      default: "",
      type: String,
    },
    subscriptionsSmoking: {
      default: "",
      type: String,
    },
    subscriptionsIAm: {
      default: "",
      type: String,
    },
    commonSubmit: {
      default: "",
      type: String,
    },
    usersAddress: {
      default: "",
      type: String,
    },
  },
  data() {
    return {}
  },
  methods: {
    changeStepNumber(value) {
      this.$store.commit('CHANGE_STEP_NUMBER', value);
    },
    submitForm: function (e) {
      e.preventDefault();
      if (this.isSubmitInProgress) return;
      let that = this;
      this.isSubmitInProgress = true;
      this.$validator.validateAll().then((res) => {
        if (res) {
          // Go to the next step
          this.changeStepNumber(2);
          window.scrollTo({ top: 0, behavior: 'smooth'});
        } else {
          that.isSubmitInProgress = false;
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },
  },
  beforeMount() {}
}
</script>


// WEBPACK FOOTER //
// resources/js/components/AccountDetailsOuterForm.vue